'use es6';

import Actions from 'AdsUI/lib/Actions';
import { List } from 'immutable';
export default ((state = List(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.TEAMS_INFO_FETCH_SUCCEEDED:
      return List(payload);

    default:
      return state;
  }
});